import type { MailboxInfo } from 'owa-client-types';
import type { ApplicationSettings } from '../store/schema/ApplicationSettings';
import { action } from 'satcheljs';

export interface ApplicationSettingsInitializedActionMessage {
    mailboxInfo: MailboxInfo | undefined;
    settings: ApplicationSettings;
}
export const applicationSettingsInitialized: (
    mailboxInfo: MailboxInfo | undefined,
    settings: ApplicationSettings
) => ApplicationSettingsInitializedActionMessage = action(
    'APPLICATION_SETTINGS_INITIALIZED',
    (
        mailboxInfo: MailboxInfo | undefined,
        settings: ApplicationSettings
    ): ApplicationSettingsInitializedActionMessage => ({
        mailboxInfo,
        settings,
    })
);
